import { HStack, Icon, Text, VStack } from '@chakra-ui/react';

import { BriefcaseOutline } from '@aslanpay/portal-common-lib';

import {
  PALETTE_COLORS,
  PALETTE_SIZES,
  PALETTE_SPACING,
  PALETTE_TRANSITIONS,
} from '../../constants';

import { CompanyItemProps } from './CompanyItem.types';

function CompanyItem({ company, index, isSelected, onSelect, onClick, itemRef }: CompanyItemProps) {
  return (
    <HStack
      role="button"
      tabIndex={0}
      ref={itemRef}
      p={PALETTE_SPACING.itemPadding}
      spacing={PALETTE_SPACING.itemSpacing}
      cursor="pointer"
      bg={isSelected ? PALETTE_COLORS.selectedBg : PALETTE_COLORS.transparent}
      _hover={{ bg: PALETTE_COLORS.selectedBg }}
      onClick={() => onClick(index)}
      onMouseEnter={() => onSelect(index)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          onClick(index);
        }
      }}
      borderLeft={
        isSelected
          ? `${PALETTE_SIZES.borderWidth} solid`
          : `${PALETTE_SIZES.borderWidth} solid transparent`
      }
      borderLeftColor={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.transparent}
      transition={PALETTE_TRANSITIONS.default}
    >
      <Icon
        as={BriefcaseOutline}
        boxSize={PALETTE_SIZES.iconSize}
        color={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.textSecondary}
      />
      <VStack align="start" spacing="2px" flex={1}>
        <Text
          fontSize={PALETTE_SIZES.fontSize}
          fontWeight={isSelected ? '600' : '500'}
          color={isSelected ? PALETTE_COLORS.selected : PALETTE_COLORS.text}
        >
          {company.name}
        </Text>
        {company.friendlyId && (
          <Text fontSize={PALETTE_SIZES.fontSizeSmall} color={PALETTE_COLORS.textSecondary}>
            {company.friendlyId}
          </Text>
        )}
      </VStack>
    </HStack>
  );
}

export default CompanyItem;
